import { ca } from '@cian/analytics';
// eslint-disable-next-line import/no-restricted-paths
import { createCianAnalyticsPageViewObject } from '../../../node/services/cianAnalyticsPageViewObject';
import { IBuildersProjectsData } from '../../types/buildersProjects';
import { TDeviceType } from '@cian/ui-kit';

interface ITrackPageView {
  buildersProjects?: IBuildersProjectsData;
  deviceType: TDeviceType;
  userId?: number;
}

export const trackPageView = (params: ITrackPageView) => {
  ca('pageviewSite', createCianAnalyticsPageViewObject(params));
};
